import React, { useEffect, useState } from "react";
import SubsidizedBoqTable from "./SubsidizedBoqTable";
import BreadCrumb from "../../../../../layout/BreadCrumb";
import Boq from "../Boq";
import InitialBoqTable from "../InitialBoqTable";
import { useDispatch, useSelector } from "react-redux";
import ConfirmModal from "../../../../../components/ConfirmModal";
import { save } from "../../../../../features/save/saveSlice";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { fetchData } from "../../../../../features/fetch/fetchSlice";
import { numberWithCommas } from "../../../../../utils";

function StandardizedList() {
  const urlTotal = "api/v2/flid/projects/getBoQTotals";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { activeObjexpIsp, dataTotal } = useSelector((state) => ({
    activeObjexpIsp: state.obj.activeObj["expressionIsp"],
    dataTotal: state.fetch.data[urlTotal] || [],
  }));
  const { saving } = useSelector((state) => state.save);
  const [initialBoq, setInitialBoq] = useState(false);
  const [active, setActive] = useState("Starndardized");
  const handleInitial = () => {
    setInitialBoq(true);
    setActive("Initial");
  };
  const handleStandandization = () => {
    setInitialBoq(false);
    setActive("Starndardized");
  };

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handlePublish = async () => {
    const res = await dispatch(
      save({
        projectBidId: activeObjexpIsp?.projectBidId,
        url: "api/v2/flid/projects/publishBoq",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await navigate("/expression-isp-list");
    } else {
      toast.error(res?.payload?.message);
    }
  };
 
  return (
    <div>
      <BreadCrumb
        breadcrumbs={[
          { title: "Farmers", path: "/farmers-list" },
          { title: "Expressions List", path: "/expression-of-interest" },
          { title: "Expression View", path: "/expression-view" },
          { title: "Standardize View" },
        ]}
      />
      <div className="white_card mt-[2.06rem] ">
        <div className="details_h !text-[1rem] ">
          Bill of Quantities: Davis and Shirtlift{" "}
        </div>
        <div className="flex items-center gap-x-[.62rem] mt-[2.75rem] ">
          <div
            className={`cursor-pointer inline-flex font-interSans h-[1.75rem] px-2 py-1 justify-center items-center 
              gap-[0.1875rem] rounded-[0.5625rem]  bg-[#9EB0CA] ${
                active === "Initial" && "border border-black"
              }`}
            onClick={handleInitial}
          >
            Initial
          </div>

          <div
            className={`inline-flex cursor-pointer font-interSans  h-[1.75rem] px-2 py-1 justify-center 
          items-center gap-[0.1875rem] rounded-[0.5625rem]  ${
            active === "Starndardized" && "border border-black"
          } bg-[#9EB0CA]`}
            onClick={handleStandandization}
          >
            Standardized
          </div>

          {activeObjexpIsp?.projectBidStatus ===
            "SUBMITTED_FOR_STANDARDIZATION" && (
            <div
              className="underline font-[700] font-interSans text-[.75rem] text-darkBlue cursor-pointer"
              onClick={handleOpenDelete}
            >
              Publish
            </div>
          )}
        </div>
        {initialBoq ? (
          <>
            <div className="rounded-[.75rem] border border-lightBlue mt-[1rem] p-[.625rem] font-interSans">
              <div className="py-[1rem]">
                <div className="flex items-center justify-between forgot-text !text-[#393939]">
                  <span>Subtotal</span>
                  <span>KES</span>
                </div>
                <div className="flex justify-end items-end text-end text-black1 text-[1rem]  font-[600]">
                  {numberWithCommas(dataTotal?.projectBoqTotalOriginal)}
                </div>
              </div>
            </div>
            <InitialBoqTable />
          </>
        ) : (
          <>
            {" "}
            <div className="rounded-[.75rem] border border-lightBlue mt-[1rem] p-[.625rem] font-interSans">
              <div className="py-[1rem]">
                <div className="flex items-center justify-between forgot-text !text-[#393939]">
                  <span>Subtotal</span>
                  <span>KES</span>
                </div>
                <div className="flex justify-end items-end text-end text-black1 text-[1rem]  font-[600]">
                  {numberWithCommas(dataTotal?.projectBoqTotalStandardized)}
                </div>
              </div>
            </div>
            <div className="font-interSans font-[700] text-[.75rem] text-black1 mt-[1.63rem]">
              {activeObjexpIsp?.projectDescription}
            </div>
            <SubsidizedBoqTable />
          </>
        )}
      </div>

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handlePublish}
        loading={saving}
        content={`Are you sure you want publish this BOQ for ${activeObjexpIsp?.microIrrigationPartnerName}`}
        type="info"
        btnTitle="Confirm"
      />
    </div>
  );
}

export default StandardizedList;
